import Type from './forms/Type'
import Position from './forms/Position'
import Location from './forms/Location'
import Detail from './forms/Detail'
import Photo from './forms/Photo'
import Presta from './forms/Presta'
import Recap from './forms/Recap'
import Manif from './forms/Manif'
import ManifExpo from './forms/ManifExpo'
import CommandSearch from './forms/CommandSearch'
import CommandSearchExpo from './forms/CommandSearchExpo'
import User from './forms/User'
import UserDetail from './forms/UserDetail'
import Command from './forms/Command'
import CommandExpo from './forms/CommandExpo'
import Site from './forms/Site'
import SiteExpo from './forms/SiteExpo'
import Map from './forms/Map'

type IncidentScreen = (props: IncidentFormProps) => JSX.Element | null

const SCREENS: { [key in IncidentStepScreen]: IncidentScreen } = {
  START: () => null, // START is a specific screen with custom props
  TYPE: Type,
  POSITION: Position,
  LOCATION: Location,
  ACTIVITY: () => null, // ACTIVITY is a specific screen iteration with custom props
  ACTIVITY_DETAIL: () => null, // ACTIVITY_DETAIL is a specific screen iteration with custom props
  DETAIL: Detail,
  PHOTO: Photo,
  PRESTA: Presta,
  RECAP: Recap,
  MANIF: Manif,
  MANIF_EXPO: ManifExpo,
  COMMAND_SEARCH: CommandSearch,
  COMMAND_SEARCH_EXPO: CommandSearchExpo,
  USER: User,
  USER_DETAIL: UserDetail,
  COMMAND: Command,
  COMMAND_EXPO: CommandExpo,
  SITE: Site,
  SITE_EXPO: SiteExpo,
  MAP: Map,
}

const START = ['START', 'SITE', 'SITE_EXPO', 'MANIF', 'MANIF_EXPO', 'TYPE'] as const
const PRESTATION = ['COMMAND_SEARCH', 'COMMAND', 'COMMAND_SEARCH_EXPO', 'COMMAND_EXPO'] as const
const INFRA = ['POSITION', 'LOCATION', 'MAP'] as const
const END = ['ACTIVITY', 'DETAIL', 'PHOTO', 'PRESTA', 'USER', 'USER_DETAIL', 'RECAP'] as const

import { AuthScope } from '@api/enum'

const getStarter = (scopes: globalThis.AuthScope[]): Partial<IncidentForm> => {
  // presta or infra or both
  const isInfra =
    scopes.includes(AuthScope.DemandesRemiseEnEtatCreation) || scopes.includes(AuthScope.DemandesIncidentCreation)
  const isPresta =
    scopes.includes(AuthScope.DemandesPrestationOrganisateurCreation) ||
    scopes.includes(AuthScope.DemandesPrestationExposantCreation)

  const TypeStarter = isInfra && isPresta ? {} : ({ isInfrastructure: isInfra ? 'INFRA' : 'PRESTA' } as const)

  return TypeStarter
}

export { SCREENS, START, PRESTATION, INFRA, END, getStarter }
